module.exports = __webpack_public_path__ + "img/img8.c783693.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img8.jpg
// module id = 303
// module chunks = 0